import { FeedbackData, IFeedbackData } from "data";
import { IFeedback } from "interfaces";

export interface IFeedbackService {
  all(): Promise<IFeedback[]>;
  find(id: string): Promise<IFeedback>;
  insert(payload: IFeedback): Promise<IFeedback>;
  update(payload: IFeedback): Promise<IFeedback>;
  delete(id: string): Promise<IFeedback>;
}

export class FeedbackService implements IFeedbackService {
  FeedbackData: IFeedbackData;

  constructor() {
    this.FeedbackData = new FeedbackData();
  }

  /**
   * fetch all the feedbacks
   * @returns {IFeedback[]} a list of feedbacks
   */
  async all() {
    const { payload: response } = await this.FeedbackData.all();
    return response;
  }

  /**
   * fetch a feedback by id
   * @param {string} id the feedback id
   * @returns {IFeedback} a feedback if found
   */
  async find(id: string) {
    if (id === "") return null;
    const { payload: response } = await this.FeedbackData.find(id);
    return response;
  }

  /**
   * Insert a feedback to the database
   * @param {IFeedback} payload the feedback data
   * @returns {IFeedback} the inserted feedback
   */
  async insert(payload: IFeedback) {
    const { payload: response } = await this.FeedbackData.insert(payload);
    return response;
  }

  /**
   * update a feedback in the database
   * @param {IFeedback} payload the feedback data to be updated
   * @returns {IFeedback} the updated feedback
   */
  async update(payload: IFeedback) {
    const { payload: response } = await this.FeedbackData.update(payload);
    return response;
  }

  /**
   * delete a feedback from the database
   * @param {string} id the feedback id
   * @returns {IFeedback} the deleted feedback
   */
  async delete(id: string) {
    const { payload: response } = await this.FeedbackData.delete(id);
    return response;
  }
}

